"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusInfo = void 0;
const react_1 = __importDefault(require("react"));
const BonusInfo = ({ info, testing }) => {
    return (react_1.default.createElement("div", { className: "border-l-2 border-slate-2" }, info.map((entry) => (react_1.default.createElement("div", { className: "pl-4 pb-4", key: entry.title },
        react_1.default.createElement("div", { className: "text-xs font-bold uppercase tracking-wider", "data-testid": testing && 'bonus_info_entry' }, entry.title),
        react_1.default.createElement("ul", { className: "", "data-testid": testing && 'bonus_info_entry_ul' }, entry.points.map((point) => (react_1.default.createElement("li", { key: point },
            "\u2022\u00A0",
            point)))))))));
};
exports.BonusInfo = BonusInfo;
